import { render, staticRenderFns } from "./PrintQrReception.vue?vue&type=template&id=2d71c262"
import script from "./PrintQrReception.vue?vue&type=script&lang=js"
export * from "./PrintQrReception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports